import api from './api';

const restify = basePath => ({
  fetch: params => {
    return api.get(basePath, params);
  },
  fetchById: id => {
    return api.get(`${basePath}/${id}`);
  },
  create: customer => {
    return api.post(basePath, customer);
  },
  update: customer => {
    return api.put(`${basePath}/${customer.id}`, customer);
  },
  approveDomain: customer => {
    return api.put(`${basePath}/approve-domain/${customer.id}`, customer);
  },
  denyDomain: userId => {
    return api.patch(`${basePath}/deny-domain`, userId);
  },
  export: () => {
    return api.get(`${basePath}` + '/export');
  },
  remove: customer => {
    return api.delete(`${basePath}/${customer.id}`);
  },
  fetchByEmail: email => {
    return api.get(`${basePath}` + '/email/' + `${email}`);
  },
});

export default restify;
